/** Notification action types*/

export const NOTIFICATION_SUCCESS = "NOTIFICATION_SUCCESS";
export const NOTIFICATION_ERROR = "NOTIFICATION_ERROR";
export const NOTIFICATION_INFO = "NOTIFICATION_INFO";
export const NOTIFICATION_WARN = "NOTIFICATION_WARN";
export { LOGOUT_REQUEST_SUCCESS } from "../authentication/redux/actionTypes";
